import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as UserActionCreators from 'actions/user';

import PasswordRequestForm from 'components/PasswordRequestForm';
import Dialog from 'components/Dialog';
import Loading from 'components/Loading';

import FacebookLoginContainer from './FacebookLoginContainer';
import GoogleLoginContainer from './GoogleLoginContainer';
import TwitterLoginContainer from './TwitterLoginContainer';

class Login extends Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    emailAddress: '',
    password: '',
    rememberMe: false,
    passwordDialogOpen: false,
    resetEmailAddress: null,
  }


  /**
   * Handle input change
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  }

  openForgotPasswordDialog = () => {
    this.setState({ passwordDialogOpen: true });
  }

  closeForgotPasswordDialog = () => {
    this.setState({ passwordDialogOpen: false });
  }

  forgotPasswordEmailChange = (e) => {
    this.setState({ resetEmailAddress: e.target.value });
  }

  redirectAfterLogin = ({ hasCharacter }) => {
    const { history } = this.props;
    // If the user already has a character, then take them to the story tab
    if (hasCharacter) {
      return history.push('/');
    }
    // If the user has no character, take them to the character-creation page
    return history.push('/create-character');
  }

  /**
   * Handle Submit
   * @param  {[type]} e [description]
   * @return {[type]}   [description]
   */
  handleSubmit = (e) => {
    const { dispatch, history, location } = this.props;
    e.preventDefault();

    const { emailAddress, password, rememberMe } = this.state;

    if (!emailAddress || !password) {
      // basic validation, this will want to be expanded
      dispatch(UserActionCreators.loginFailure());
      return;
    }

    // Where does the user want us to keep the access token?
    const storage = rememberMe ? 'localStorage' : 'sessionStorage';
    // API services will check this to decide where to put the token
    window.sessionStorage.setItem('storage', storage);

    dispatch(UserActionCreators.loginUser(this.state, location, history));
  }

  /**
   * Render
   * @return {Object}
   */
  render() {
    const {
      isFetching,
      loginError,
    } = this.props;

    const {
      emailAddress,
      password,
      passwordDialogOpen,
      rememberMe,
    } = this.state;

    return (
      <div role="tabpanel" className="tab-pane active" id="log-in">
        <h2 className="heading heading--2 heading--hr">Log in</h2>
        <form onSubmit={this.handleSubmit}>

          <p className="form__group">
            <label htmlFor="emailAddress">Email address</label>
            <input
              type="email"
              className="form__control"
              id="emailAddress"
              name="emailAddress"
              onChange={this.handleChange}
              value={emailAddress}
            />
          </p>

          <p className="form__group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form__control"
              id="password"
              name="password"
              onChange={this.handleChange}
              value={password}
            />
          </p>

          <div className="login__remember-me-and-submit">
            <span className="login__remember-me">
              <span className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    onChange={this.handleChange}
                    name="rememberMe"
                    value={rememberMe}
                  />
                  {' '}
                  Remember me
                </label>
              </span>
            </span>
            <button
              className="button button--primary"
              disabled={isFetching}
              type="submit"
            >
              {isFetching ? <Loading spinner small /> : 'Log in'}
            </button>
          </div>

          <p>{isFetching ? 'Logging in...' : null}</p>
          <p>{loginError ? 'We were not able to log you in with the credentials you supplied.' : null}</p>
          <p>
            <button
              className="button--link button--link-inverse"
              onClick={this.openForgotPasswordDialog}
              type="button"
            >
              Forgotten your password?
            </button>
          </p>
        </form>
        <Dialog isOpen={passwordDialogOpen} onRequestClose={this.closeForgotPasswordDialog}>
          <PasswordRequestForm />
        </Dialog>
        <hr />

        <p className="u-text-center">or</p>

        <p className="fb-root">
          <FacebookLoginContainer label="Log in with Facebook" />
        </p>

        <p className="u-text-center">or</p>

        <TwitterLoginContainer label="Log in with Twitter" />

        <p className="u-text-center">or</p>

        <GoogleLoginContainer label="Log in with Google" />

      </div>
    );
  }
}

Login.displayName = 'Login';

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  loginError: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isFetching: state.user.isFetching,
  loginError: state.user.loginError,
});

export default withRouter(connect(mapStateToProps)(Login));
